/* REFLOW — assistant de conseil et de service client (section rf-assistant).
   - Test « Trouver mon appareil » en 5 questions, puis recommandation et ajout au panier.
   - Questions libres : les réponses viennent uniquement des contenus de la section (appareils,
     faits vérifiés, questions) et des réglages du thème. Sans réponse sûre, l'assistant le dit
     et propose un conseiller (WhatsApp, e-mail, téléphone).
   - Rien n'est envoyé à un service tiers ; la conversation est gardée le temps de la visite.
   - La bulle se place au-dessus du bouton WhatsApp et le suit (barre d'achat, bandeaux). */
(function () {
  if (customElements.get('rf-assistant')) return;

  var STORE = 'rf-asst-v1';
  var Q_KEY = 'rf-asst-question';
  var TEASED = 'rf-asst-teased';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqMobile = window.matchMedia('(max-width: 639px)');
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var QUIZ = [
    { id: 'zone', multi: true, o: [['jambes', 'legs'], ['mollets', 'calf'], ['dos', 'back'], ['nuque', 'neck'], ['epaule', 'shoulder'], ['genou', 'knee'], ['sport', 'muscle']] },
    { id: 'moment', o: [['sport', 'run'], ['journee', 'sun'], ['bureau', 'home'], ['soir', 'sofa'], ['deplacement', 'pin']] },
    { id: 'sens', multi: true, o: [['compression', 'air'], ['chaleur', 'heat'], ['percussion', 'percussion'], ['petrissage', 'kneading'], ['vibration', 'vibration'], ['indecis', 'help']] },
    { id: 'power', o: [['sansfil', 'battery'], ['secteur', 'plug'], ['egal', 'check']] },
    { id: 'safety', multi: true, only: 'aucune', o: [['grossesse'], ['implant'], ['circulation'], ['coeur'], ['peau'], ['aucune']] }
  ];

  /* Vocabulaire, en forme normalisée (minuscules, sans accents ni apostrophes).
     Une expression de plusieurs mots compte 3, un mot exact 2, une variante (pluriel, féminin) 1,5. */
  var TOPICS = {
    precautions: ['precaution', 'precautions', 'contre indication', 'contre indications', 'enceinte', 'grossesse', 'pacemaker', 'stimulateur', 'danger', 'dangereux', 'dangereuse', 'risque', 'risques', 'deconseille', 'sans danger', 'phlebite', 'thrombose', 'epilepsie', 'implant'],
    prix: ['prix', 'combien coute', 'combien ca coute', 'coute', 'coutent', 'cout', 'tarif', 'euros'],
    quantite: ['unite', 'a l unite', 'paire', 'par paire', 'deux jambes', 'les deux jambes', 'par deux', 'lot'],
    embouts: ['embout', 'embouts', 'tete', 'tetes'],
    application: ['application', 'appli', 'app', 'smartphone', 'bluetooth', 'iphone', 'android', 'depuis mon telephone'],
    autonomie: ['autonomie', 'batterie', 'recharge', 'recharger', 'rechargeable', 'charge', 'charger', 'tient', 'mah'],
    alimentation: ['secteur', 'prise', 'brancher', 'branche', 'branchee', 'branchees', 'electrique', 'alimentation', 'sans fil', 'fil', 'filaire', 'cable', 'pile', 'piles', 'usb'],
    taille: ['taille', 'tour', 'tour de cuisse', 'tour de taille', 'tour de mollet', 'mesure', 'mesures', 'morphologie', 'grand', 'grande', 'grosse', 'grosses', 'petit', 'petite', 'ajuste', 'ajustable', 'ajustement', 'rentre', 'convient', 'xl', 'xxl'],
    contenu: ['boite', 'contenu', 'coffret', 'inclus', 'incluse', 'inclut', 'fourni', 'fournie', 'fournis', 'livre avec', 'livree avec', 'livrees avec', 'dedans', 'accessoire', 'accessoires'],
    chaleur: ['chaleur', 'chauffe', 'chauffent', 'chauffant', 'chauffante', 'chauffer', 'temperature', 'degre', 'degres', 'chaud', 'chaude'],
    seance: ['seance', 'seances', 'combien de temps', 'minutes', 'minute', 'duree', 'frequence', 'par jour', 'chaque jour', 'tous les jours', 'souvent', 'arret automatique', 'minuterie', 's arrete'],
    reglages: ['reglage', 'reglages', 'regler', 'reglable', 'mode', 'modes', 'intensite', 'intensites', 'niveau', 'niveaux', 'programme', 'programmes', 'vitesse', 'vitesses', 'telecommande', 'ecran', 'puissant', 'puissante', 'puissance', 'fort', 'forte'],
    entretien: ['entretien', 'entretenir', 'laver', 'lavable', 'lavage', 'nettoyer', 'nettoyage', 'ranger', 'rangement'],
    bruit: ['bruit', 'bruyant', 'bruyante', 'silencieux', 'silencieuse', 'decibel', 'decibels', 'db', 'sonore'],
    poids: ['poids', 'kg', 'kilo', 'kilos', 'dimension', 'dimensions', 'encombrement', 'encombrant'],
    couleurs: ['couleur', 'couleurs', 'coloris', 'blanc', 'blanche', 'gris', 'grise', 'noir', 'noire'],
    fonctionnement: ['comment ca marche', 'comment ca fonctionne', 'comment marche', 'fonctionnement', 'principe', 'compression', 'ems', 'electrostimulation', 'percussion', 'petrissage', 'chambre', 'chambres']
  };
  var ZONES = {
    jambes: ['jambe', 'jambes', 'cuisse', 'cuisses', 'pied', 'pieds', 'jambes lourdes', 'jambes fatiguees'],
    mollets: ['mollet', 'mollets'],
    dos: ['dos', 'lombaire', 'lombaires', 'lombalgie', 'reins', 'bas du dos'],
    nuque: ['nuque', 'cou', 'cervicale', 'cervicales', 'trapeze', 'trapezes', 'haut du dos'],
    epaule: ['epaule', 'epaules'],
    genou: ['genou', 'genoux'],
    sport: ['sport', 'sportif', 'sportive', 'course', 'courir', 'running', 'footing', 'jogging', 'muscu', 'musculation', 'crossfit', 'velo', 'randonnee', 'courbature', 'courbatures', 'entrainement', 'trail', 'marathon', 'football', 'rugby', 'tennis', 'muscle', 'muscles']
  };
  var HUMAN = ['conseiller', 'un conseiller', 'parler a', 'parler avec', 'humain', 'une personne', 'quelqu un', 'service client', 'joindre', 'appeler', 'rappeler', 'telephone', 'numero de telephone', 'whatsapp', 'contacter', 'vous contacter', 'vous ecrire', 'email', 'e mail', 'mail', 'adresse mail'];
  var CHOOSE = ['conseil', 'conseillez', 'choisir', 'choix', 'lequel', 'laquelle', 'quel appareil', 'quel produit', 'recommande', 'recommandez', 'recommandation', 'ideal', 'pour moi', 'besoin', 'je cherche', 'cherche', 'offrir', 'cadeau', 'adapte'];
  var PAIN = ['mal', 'douleur', 'douleurs', 'tension', 'tensions', 'raideur', 'lourdes', 'lourdeur', 'fatigue', 'fatiguees', 'fatigues', 'detendre', 'detente', 'soulager', 'relaxer', 'relaxation', 'recuperer', 'recuperation', 'courbature', 'courbatures', 'contracture', 'noue', 'noues'];
  var STRONG_PAIN = ['mal', 'douleur', 'douleurs', 'raideur', 'contracture'];
  var COMPARE = ['difference', 'differences', 'comparer', 'compare', 'comparaison', 'vs', 'versus', 'ou bien', 'plutot', 'mieux'];
  var HELLO = ['bonjour', 'salut', 'hello', 'bonsoir', 'coucou', 'hey'];
  var THANKS = ['merci', 'super', 'parfait', 'top', 'genial', 'd accord', 'ok'];

  function norm(s) {
    return String(s || '').toLowerCase().replace(/œ/g, 'oe').replace(/æ/g, 'ae')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function csv(s) { return String(s || '').split(',').map(norm).filter(Boolean); }
  function fill(s, vars) {
    s = String(s || '');
    Object.keys(vars || {}).forEach(function (k) { s = s.split('[' + k + ']').join(vars[k]); });
    return s;
  }
  function lcFirst(s) { s = String(s || ''); return s.charAt(0).toLowerCase() + s.slice(1); }
  function store(get, val) {
    try {
      if (get) return JSON.parse(sessionStorage.getItem(STORE) || 'null');
      sessionStorage.setItem(STORE, JSON.stringify(val));
    } catch (e) { return null; }
  }
  function flag(key, set) {
    try { if (set) sessionStorage.setItem(key, '1'); return sessionStorage.getItem(key) === '1'; } catch (e) { return false; }
  }

  /* Score d'un texte normalisé (entouré d'espaces) contre une liste de mots-clés. */
  function score(padded, words, out) {
    var s = 0;
    var toks = padded.trim().split(' ');
    words.forEach(function (w) {
      if (!w) return;
      if (w.indexOf(' ') > -1) {
        if (padded.indexOf(' ' + w + ' ') > -1) { s += 3; if (out) out.push(w); }
        return;
      }
      for (var i = 0; i < toks.length; i++) {
        var tk = toks[i];
        if (tk === w) { s += 2; if (out) out.push(w); return; }
        if (w.length >= 4 && tk.indexOf(w) === 0 && tk.length - w.length <= 3) { s += 1.5; if (out) out.push(w); return; }
      }
    });
    return s;
  }

  class RfAssistant extends HTMLElement {
    connectedCallback() {
      var raw = this.querySelector('[data-rf-asst-data]');
      try { this.data = JSON.parse(raw.textContent); } catch (e) { return; }
      var d = this.data;
      var T = this.T = {};
      var dec = document.createElement('textarea');
      /* Le filtre t échappe le HTML (apostrophes en &#39;) : on décode pour du texte brut. */
      Object.keys(d.t || {}).forEach(function (k) { dec.innerHTML = d.t[k]; T[k] = dec.value; });
      d.products.forEach(function (p) {
        p.nameList = csv(p.names).concat(csv(p.short));
        p.zoneList = csv(p.zones);
        p.momentList = csv(p.moments);
        p.sensList = csv(p.sens);
        p.cautionList = csv(p.cautions);
        p.factMap = {};
        String(p.facts || '').split(/\r?\n/).forEach(function (line) {
          var m = line.match(/^\s*([a-z]+)\s*:\s*(.+)$/i);
          if (m) p.factMap[norm(m[1])] = m[2].trim();
        });
      });
      d.faq.forEach(function (f) { f.kw = csv(f.k); });

      this.icons = {};
      var tpl = this.querySelector('template[data-rf-asst-icons]');
      if (tpl) tpl.content.querySelectorAll('[data-i]').forEach(function (s) { this.icons[s.dataset.i] = s.innerHTML; }, this);

      this.launcher = this.querySelector('[data-rf-asst-toggle]');
      this.launcherLabel = this.querySelector('[data-rf-asst-toggle-label]');
      this.panel = this.querySelector('.rf-asst__panel');
      this.log = this.querySelector('[data-rf-asst-log]');
      this.form = this.querySelector('[data-rf-asst-form]');
      this.input = this.form.querySelector('input');
      this.progress = this.querySelector('[data-rf-asst-progress]');
      this.teaser = this.querySelector('[data-rf-asst-teaser]');
      this.queue = Promise.resolve();
      this.via = 'click';

      var saved = store(true) || {};
      this.state = { log: saved.log || [], quiz: saved.quiz || null, ctx: saved.ctx || null, last: saved.last || '', open: !!saved.open };
      var pageP = d.context.product && this.byHandle(d.context.product);
      if (pageP) this.state.ctx = pageP.h;

      this.onClick = this.onClick.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onKey = this.onKey.bind(this);
      this.place = this.place.bind(this);
      this.follow = this.follow.bind(this);
      this.onEditor = this.onEditor.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.form.addEventListener('submit', this.onSubmit);
      window.addEventListener('resize', this.place);
      this.observer = new MutationObserver(this.follow);
      this.observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('shopify:section:select', this.onEditor);
      document.addEventListener('shopify:section:deselect', this.onEditor);

      this.state.log.forEach(function (m) { this.mount(m); }, this);
      this.hidden = false;
      this.place();
      setTimeout(this.place, 600);
      if (this.state.open && !mqMobile.matches) this.open(false);
      else { this.state.open = false; this.save(); }
      this.scheduleTeaser();
    }

    disconnectedCallback() {
      if (!this.data) return;
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      window.removeEventListener('resize', this.place);
      if (this.observer) this.observer.disconnect();
      document.removeEventListener('shopify:section:select', this.onEditor);
      document.removeEventListener('shopify:section:deselect', this.onEditor);
      clearTimeout(this.teaserTimer);
      cancelAnimationFrame(this.raf);
      document.documentElement.classList.remove('rf-locked');
    }

    t(k, vars) { return fill(this.T[k] || '', vars); }
    icon(n) { return this.icons[n] || ''; }
    byHandle(h) { return this.data.products.filter(function (p) { return p.h === h; })[0] || null; }
    save() {
      store(false, { log: this.state.log.slice(-40), quiz: this.state.quiz, ctx: this.state.ctx, last: this.state.last, open: this.state.open });
    }

    /* ---------- Position : au-dessus du bouton WhatsApp ---------- */
    /* N'écrit dans le DOM que si la position change : d'autres scripts (Moon Bundles, correctif
       sticky) réagissent aux mutations, une écriture systématique relancerait la boucle à l'infini. */
    place() {
      var wa = document.querySelector('.reflow-wa');
      var cs = wa && getComputedStyle(wa);
      var size = wa ? wa.getBoundingClientRect().width : 0;
      var visible = cs && cs.display !== 'none' && cs.visibility !== 'hidden' && size > 0;
      var key = visible ? [parseFloat(cs.right), parseFloat(cs.bottom) + size + 12, size].join('|') : 'solo';
      if (key === this.placed) return;
      this.placed = key;
      if (visible) {
        var v = key.split('|');
        this.style.setProperty('--rf-asst-right', v[0] + 'px');
        this.style.setProperty('--rf-asst-bottom', v[1] + 'px');
        this.style.setProperty('--rf-asst-size', v[2] + 'px');
        if (this.classList.contains('rf-asst--solo')) this.classList.remove('rf-asst--solo');
      } else {
        this.style.removeProperty('--rf-asst-right');
        this.style.removeProperty('--rf-asst-bottom');
        this.style.removeProperty('--rf-asst-size');
        if (!this.classList.contains('rf-asst--solo')) this.classList.add('rf-asst--solo');
      }
    }
    /* Le bouton WhatsApp remonte avec une transition quand la barre d'achat apparaît : on le suit. */
    follow() {
      var self = this;
      var end = Date.now() + 400;
      cancelAnimationFrame(this.raf);
      (function step() {
        self.place();
        if (Date.now() < end) self.raf = requestAnimationFrame(step);
      })();
    }

    /* ---------- Ouverture ---------- */
    open(focus) {
      clearTimeout(this.teaserTimer);
      this.hideTeaser();
      this.panel.hidden = false;
      this.classList.add('is-open');
      this.launcher.setAttribute('aria-expanded', 'true');
      this.launcherLabel.textContent = this.T.close;
      if (mqMobile.matches) document.documentElement.classList.add('rf-locked');
      this.state.open = true;
      flag(TEASED, true);
      if (!this.state.log.length) this.greet();
      this.save();
      this.scrollEnd();
      if (focus !== false) this.querySelector('#rf-asst-title').focus({ preventScroll: true });
    }
    close(focus) {
      this.panel.hidden = true;
      this.classList.remove('is-open');
      this.launcher.setAttribute('aria-expanded', 'false');
      this.launcherLabel.textContent = this.T.open;
      document.documentElement.classList.remove('rf-locked');
      this.state.open = false;
      this.save();
      if (focus !== false) this.launcher.focus({ preventScroll: true });
    }
    onEditor(e) {
      if (!this.closest('.shopify-section') || e.target !== this.closest('.shopify-section')) return;
      if (e.type === 'shopify:section:select') this.open(false); else this.close(false);
    }

    /* ---------- Invitation ---------- */
    scheduleTeaser() {
      var delay = Number(this.data.settings.teaserDelay) || 0;
      if (!delay || flag(TEASED) || this.state.open || this.data.context.page === 'cart' || (window.Shopify && window.Shopify.designMode)) return;
      var self = this;
      var tries = 0;
      this.teaserTimer = setTimeout(function tick() {
        if (self.state.open) return;
        if ((self.consentVisible() || document.querySelector('dialog[open]')) && tries++ < 10) { self.teaserTimer = setTimeout(tick, 3000); return; }
        var p = self.state.ctx && self.byHandle(self.state.ctx);
        var text = p && self.data.context.product ? self.t('teaser_product', { x: p.short }) : self.data.settings.teaser;
        if (!text) return;
        self.querySelector('[data-rf-asst-teaser-open]').textContent = text;
        self.teaser.hidden = false;
        flag(TEASED, true);
        self.teaserTimer = setTimeout(function () { self.hideTeaser(); }, 15000);
      }, delay * 1000);
    }
    hideTeaser() { if (this.teaser) this.teaser.hidden = true; }
    consentVisible() {
      var host = document.getElementById('cst-shadow-host');
      if (host && host.shadowRoot && getComputedStyle(host).display !== 'none') {
        var b = host.shadowRoot.querySelector('#ot-cookie-banner, #cookies-wrapper, [class*="cookie-banner"]');
        if (b && b.getBoundingClientRect().height > 0 && getComputedStyle(b).display !== 'none') return true;
      }
      return false;
    }

    /* ---------- Messages ---------- */
    mount(m) {
      var el = document.createElement('div');
      el.className = m.c;
      el.innerHTML = m.h;
      el._rfMsg = m;
      this.log.appendChild(el);
      return el;
    }
    push(cls, html) {
      var m = { c: cls, h: html };
      this.state.log.push(m);
      if (this.state.log.length > 60) this.state.log.shift();
      var el = this.mount(m);
      this.save();
      return el;
    }
    /* Met à jour la copie mémorisée d'un message modifié (choix cochés, boutons désactivés). */
    commit(el) {
      var turn = el.closest('.rf-asst__turn');
      if (turn && turn._rfMsg) { turn._rfMsg.h = turn.innerHTML; this.save(); }
    }
    user(text) {
      this.push('rf-asst__turn rf-asst__turn--me', '<div class="rf-asst__bubble">' + esc(text) + '</div>');
      this.scrollEnd();
    }
    /* Réponse de l'assistant : texte dans une bulle, compléments (cartes, choix) en dessous. */
    bot(text, extra, opts) {
      opts = opts || {};
      var self = this;
      var via = this.via;
      this.queue = this.queue.then(function () {
        return self.typing(opts.fast ? 150 : Math.min(900, 280 + String(text || '').length * 3));
      }).then(function () {
        var html = '<span class="rf-asst__avatar rf-asst__avatar--sm" aria-hidden="true">R</span><div class="rf-asst__stack">';
        if (text) html += '<div class="rf-asst__bubble">' + text + '</div>';
        if (opts.human) html += self.humanBlock(opts.product, opts.motif);
        if (extra) html += '<div class="rf-asst__extra">' + extra + '</div>';
        html += '</div>';
        var el = self.push('rf-asst__turn rf-asst__turn--bot', html);
        self.scrollTo(el);
        if (via === 'click' && opts.focus !== false) {
          var first = el.querySelector('.rf-asst__extra button:not([disabled]), .rf-asst__extra a:not([tabindex="-1"]), .rf-asst__extra select');
          if (first) first.focus({ preventScroll: true });
        }
        return el;
      });
      return this.queue;
    }
    typing(ms) {
      if (reduce || ms <= 0) return Promise.resolve();
      var el = document.createElement('div');
      el.className = 'rf-asst__turn rf-asst__turn--bot rf-asst__typing';
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML = '<span class="rf-asst__avatar rf-asst__avatar--sm">R</span><div class="rf-asst__bubble"><i></i><i></i><i></i></div>';
      this.log.appendChild(el);
      this.scrollEnd();
      return new Promise(function (r) { setTimeout(function () { el.remove(); r(); }, ms); });
    }
    scrollEnd() { this.log.scrollTop = this.log.scrollHeight; }
    scrollTo(el) {
      if (el.offsetHeight > this.log.clientHeight - 24) this.log.scrollTop = el.offsetTop - 8;
      else this.scrollEnd();
    }
    chips(list) {
      var self = this;
      return '<div class="rf-asst__chips">' + list.filter(Boolean).map(function (c) {
        var cls = 'rf-asst__chip' + (c.primary ? ' rf-asst__chip--primary' : '');
        var ico = c.icon ? self.icon(c.icon) : '';
        if (c.href) return '<a class="' + cls + '" href="' + esc(c.href) + '"' + (c.act ? ' data-act="' + c.act + '"' : '') + '>' + ico + '<span>' + esc(c.label) + '</span></a>';
        var attrs = ' data-act="' + c.act + '"' + (c.v != null ? ' data-v="' + esc(c.v) + '"' : '') + (c.h ? ' data-h="' + esc(c.h) + '"' : '');
        return '<button type="button" class="' + cls + '"' + attrs + '>' + ico + '<span>' + esc(c.label) + '</span></button>';
      }).join('') + '</div>';
    }
    menuChips(withQuiz) {
      var self = this;
      var p = this.state.ctx && this.byHandle(this.state.ctx);
      var list = [];
      if (withQuiz !== false) list.push({ act: 'quiz', label: this.T.chip_quiz, icon: 'check-circle', primary: true });
      if (p) list.push({ act: 'prod', h: p.h, label: this.t('chip_product', { x: p.short }) });
      this.data.faq.forEach(function (f, i) { if (f.chip) list.push({ act: 'faq', v: i, label: f.chip }); });
      list.push({ act: 'human', label: self.T.chip_human, icon: 'chat' });
      return this.chips(list);
    }

    /* ---------- Conseiller ---------- */
    humanBlock(p, motif) {
      var s = this.data.settings;
      var q = this.state.last;
      var html = '<div class="rf-asst__human"><p>' + esc(this.t('human_intro', { hours: lcFirst(s.hours) })) + '</p><div class="rf-asst__acts">';
      if (s.wa) {
        var msg = q ? 'Bonjour, ' + lcFirst(q) : this.T.wa_default;
        if (p) msg += ' (' + p.title + ')';
        html += '<a class="rf-asst__act rf-asst__act--wa" href="https://wa.me/' + esc(s.wa) + '?text=' + encodeURIComponent(msg) + '" target="_blank" rel="noopener">' + this.icon('whatsapp') + '<span>' + esc(this.T.human_wa) + '</span></a>';
      }
      var url = s.contact + '?motif=' + encodeURIComponent(motif || 'Question avant achat') + (p ? '&produit=' + encodeURIComponent(p.h) : '');
      html += '<a class="rf-asst__act" href="' + esc(url) + '" data-act="mail">' + this.icon('mail') + '<span>' + esc(this.T.human_mail) + '</span></a>';
      if (s.tel) html += '<a class="rf-asst__act" href="tel:' + esc(s.tel.replace(/\s/g, '')) + '">' + this.icon('phone') + '<span>' + esc(this.t('human_call', { phone: s.phone })) + '</span></a>';
      return html + '</div><p class="rf-asst__small">' + esc(this.T.human_mail_delay) + '</p></div>';
    }

    /* ---------- Accueil et menu ---------- */
    greet() {
      var s = this.data.settings;
      var p = this.data.context.product && this.byHandle(this.data.context.product);
      var text = '<p>' + esc(s.greeting || this.T.greet) + '</p>';
      if (p) text += '<p>' + esc(this.t('greet_product', { x: p.short })) + '</p>';
      else text += '<p>' + esc(this.T.menu_intro) + '</p>';
      this.bot(text, this.menuChips(), { fast: true, focus: false });
    }
    menu() { this.bot('<p>' + esc(this.T.menu_intro) + '</p>', this.menuChips(), { fast: true }); }
    restart() {
      this.state.log = [];
      this.state.quiz = null;
      this.state.last = '';
      this.log.innerHTML = '';
      this.setProgress(null);
      this.save();
      this.greet();
    }

    /* ---------- Test « Trouver mon appareil » ---------- */
    setProgress(ratio) {
      this.panel.classList.toggle('is-quiz', ratio != null);
      if (this.progress) this.progress.style.width = ratio == null ? '0' : Math.round(ratio * 100) + '%';
    }
    startQuiz() {
      this.state.quiz = { i: 0, a: {} };
      this.save();
      this.askStep();
    }
    askStep() {
      var self = this;
      var i = this.state.quiz.i;
      var q = QUIZ[i];
      this.setProgress(i / QUIZ.length);
      var label = this.T['q_' + q.id];
      var text = '<p class="rf-asst__step">' + esc(this.t('step', { n: i + 1, total: QUIZ.length })) + '</p><p>' + esc(label) + '</p>' + (q.multi ? '<p class="rf-asst__hint">' + esc(this.T.multi_hint) + '</p>' : '');
      var extra = '<div class="rf-asst__opts" role="group" aria-label="' + esc(label) + '" data-step="' + i + '">' + q.o.map(function (o) {
        return '<button type="button" class="rf-asst__opt" data-act="opt" data-v="' + o[0] + '"' + (q.multi ? ' aria-pressed="false"' : '') + '>' + (o[1] ? self.icon(o[1]) : '') + '<span>' + esc(self.T['o_' + q.id + '_' + o[0]]) + '</span></button>';
      }).join('') + '</div>';
      if (q.multi) extra += '<button type="button" class="rf-asst__next" data-act="next" data-step="' + i + '" disabled><span>' + esc(this.T.next) + '</span>' + this.icon('arrow') + '</button>';
      this.bot(text, extra);
    }
    pick(btn) {
      var group = btn.closest('.rf-asst__opts');
      var quiz = this.state.quiz;
      if (!quiz || Number(group.dataset.step) !== quiz.i) { this.lock(group.closest('.rf-asst__extra')); return; }
      var q = QUIZ[quiz.i];
      if (!q.multi) {
        btn.classList.add('is-on');
        this.answer(q, [btn.dataset.v], group.closest('.rf-asst__extra'));
        return;
      }
      var on = btn.getAttribute('aria-pressed') !== 'true';
      if (on && q.only) {
        group.querySelectorAll('.rf-asst__opt').forEach(function (b) {
          if ((btn.dataset.v === q.only) !== (b.dataset.v === q.only)) { b.setAttribute('aria-pressed', 'false'); b.classList.remove('is-on'); }
        });
      }
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on);
      var next = group.parentNode.querySelector('[data-act="next"]');
      if (next) next.disabled = !group.querySelector('[aria-pressed="true"]');
      this.commit(group);
    }
    next(btn) {
      var extra = btn.closest('.rf-asst__extra');
      var quiz = this.state.quiz;
      if (!quiz || Number(btn.dataset.step) !== quiz.i) { this.lock(extra); return; }
      var vals = [].map.call(extra.querySelectorAll('[aria-pressed="true"]'), function (b) { return b.dataset.v; });
      if (vals.length) this.answer(QUIZ[quiz.i], vals, extra);
    }
    lock(extra) {
      if (!extra) return;
      extra.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
      extra.classList.add('is-done');
      this.commit(extra);
    }
    answer(q, vals, extra) {
      var self = this;
      this.lock(extra);
      this.state.quiz.a[q.id] = vals;
      this.user(vals.map(function (v) { return self.T['o_' + q.id + '_' + v]; }).join(', '));
      this.state.quiz.i++;
      this.save();
      if (this.state.quiz.i >= QUIZ.length) this.result();
      else this.askStep();
    }

    /* Classement : la zone domine (6 pour la zone principale de l'appareil, 3 sinon),
       puis moment et sensations (2 chacun) ; « sans fil » demandé pénalise un appareil sur secteur. */
    rank(a) {
      var zones = a.zone || [];
      var moment = (a.moment || [])[0];
      var sens = (a.sens || []).filter(function (x) { return x !== 'indecis'; });
      var power = (a.power || [])[0];
      var safety = (a.safety || []).filter(function (x) { return x !== 'aucune'; });
      return this.data.products.map(function (p) {
        var r = { p: p, s: 0, zones: [], sens: [], flags: [] };
        zones.forEach(function (z) {
          var i = p.zoneList.indexOf(z);
          if (i === 0) { r.s += 6; r.zones.push(z); } else if (i > 0) { r.s += 3; r.zones.push(z); }
        });
        if (moment && p.momentList.indexOf(moment) > -1) r.s += 2;
        sens.forEach(function (x) { if (p.sensList.indexOf(x) > -1) { r.s += 2; r.sens.push(x); } });
        if (power === 'sansfil') r.s += p.wireless ? 2 : -4;
        if (!p.avail) r.s -= 1;
        r.flags = safety.filter(function (x) { return p.cautionList.indexOf(x) > -1; });
        return r;
      }).sort(function (x, y) { return y.s - x.s; });
    }
    pickTwo(ranked, zones) {
      var top = ranked[0];
      var alt = null;
      var missing = (zones || []).filter(function (z) { return top.p.zoneList.indexOf(z) === -1; });
      if (missing.length) alt = ranked.slice(1).filter(function (r) { return r.zones.some(function (z) { return missing.indexOf(z) > -1; }); })[0] || null;
      if (!alt && ranked[1] && ranked[1].s > 0 && ranked[1].s >= top.s * 0.6) alt = ranked[1];
      return { top: top, alt: alt };
    }
    why(r, a) {
      var self = this;
      var out = [];
      if (r.zones.length) out.push(this.t('why_zone', { x: r.zones.map(function (z) { return lcFirst(self.T['o_zone_' + z]); }).join(', ') }));
      r.sens.forEach(function (x) { out.push(self.T['o_sens_' + x]); });
      if (r.p.wireless) out.push(this.T.why_wireless); else if (a && a.power && a.power[0] !== 'sansfil') out.push(this.T.why_mains);
      return out.slice(0, 3);
    }
    result() {
      var self = this;
      var a = this.state.quiz.a;
      this.state.quiz = null;
      this.setProgress(1);
      var ranked = this.rank(a);
      var two = this.pickTwo(ranked, a.zone);
      var top = two.top;
      this.state.ctx = top.p.h;
      this.save();
      var text = '<p>' + esc(top.s > 4 ? this.T.result_intro : this.T.result_unsure) + '</p>';
      if (top.flags.length) {
        text += '<p class="rf-asst__caution">' + this.icon('alert') + '<span>' + esc(this.t('caution', { items: top.flags.map(function (f) { return lcFirst(self.T['o_safety_' + f]); }).join(', ') })) + '</span></p>';
      }
      var extra = this.card(top.p, { kicker: this.T.result_best, why: this.why(top, a), flags: top.flags });
      if (two.alt) extra += this.card(two.alt.p, { kicker: this.T.result_alt, why: this.why(two.alt, a).slice(0, 2), flags: two.alt.flags, alt: true });
      this.bot(text, extra, { human: top.flags.length > 0, product: top.p }).then(function () {
        self.setProgress(null);
        self.bot('<p>' + esc(self.T.after_result) + '</p>', self.chips([
          { act: 'prod', h: top.p.h, label: self.t('chip_product', { x: top.p.short }) },
          { act: 'quiz', label: self.T.chip_retry, icon: 'return' },
          { act: 'human', label: self.T.chip_human, icon: 'chat' },
          { act: 'menu', label: self.T.chip_menu }
        ]), { fast: true, focus: false });
      });
    }

    /* ---------- Cartes produit ---------- */
    card(p, o) {
      o = o || {};
      var self = this;
      var h = '<article class="rf-asst__card' + (o.alt ? ' rf-asst__card--alt' : '') + '">';
      h += '<div class="rf-asst__card-top"><a class="rf-asst__card-media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true" data-act="link">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="96" height="96" loading="lazy">' : '') + '</a>';
      h += '<div class="rf-asst__card-head">';
      if (o.kicker) h += '<p class="rf-asst__kicker">' + esc(o.kicker) + '</p>';
      h += '<h3 class="rf-asst__card-title"><a href="' + esc(p.url) + '" data-act="link">' + esc(p.title) + '</a></h3>';
      h += '<p class="rf-asst__price">' + esc(p.price) + (p.cmp ? ' <s>' + esc(p.cmp) + '</s>' : '') + '</p></div></div>';
      if (p.pitch && !o.alt) h += '<p class="rf-asst__pitch">' + esc(p.pitch) + '</p>';
      if (o.why && o.why.length) h += '<ul class="rf-asst__why">' + o.why.map(function (w) { return '<li>' + self.icon('check') + '<span>' + esc(w) + '</span></li>'; }).join('') + '</ul>';
      if (o.flags && o.flags.length) h += '<p class="rf-asst__tag">' + this.icon('alert') + '<span>' + esc(this.T.caution_tag) + '</span></p>';
      h += this.buy(p, o);
      return h + '</article>';
    }
    buy(p, o) {
      var see = '<a class="rf-asst__link" href="' + esc(p.url) + '" data-act="link">' + esc(this.T.see) + this.icon('arrow') + '</a>';
      if (o.flags && o.flags.length) return '<div class="rf-asst__buy">' + see + '</div>';
      if (!p.avail) return '<p class="rf-asst__small">' + esc(this.T.unavailable) + '</p><div class="rf-asst__buy">' + see + '</div>';
      var h = '';
      if (!p.single && p.vs.length > 1) {
        h += '<label class="rf-asst__variant"><span>' + esc(p.opt) + '</span><select data-rf-asst-variant>' + p.vs.map(function (v) {
          return '<option value="' + v.id + '"' + (v.a ? '' : ' disabled') + (v.id === p.v ? ' selected' : '') + '>' + esc(v.t) + '</option>';
        }).join('') + '</select></label>';
      }
      h += '<div class="rf-asst__buy"><button type="button" class="rf-asst__btn" data-act="add" data-h="' + esc(p.h) + '">' + this.icon('bag') + '<span>' + esc(this.T.add) + '</span></button>' + see + '</div>';
      if (p.qty) h += '<p class="rf-asst__small">' + esc(p.qty) + '</p>';
      return h;
    }
    add(btn) {
      var self = this;
      var p = this.byHandle(btn.dataset.h);
      if (!p) return;
      var cardEl = btn.closest('.rf-asst__card');
      var sel = cardEl && cardEl.querySelector('[data-rf-asst-variant]');
      var id = sel ? parseInt(sel.value, 10) : p.v;
      var label = btn.querySelector('span');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      label.textContent = this.T.adding;
      function done() { btn.disabled = false; btn.removeAttribute('aria-busy'); label.textContent = self.T.add; }
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw new Error(j && (j.description || j.message) || ''); return j; });
      }).then(function () {
        return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      }).then(function (cart) {
        done();
        self.state.ctx = p.h;
        self.via = 'auto';
        self.bot('<p>' + self.icon('check-circle') + ' ' + esc(self.T.added) + '</p>', self.chips([
          { href: self.data.settings.cart, label: self.T.view_cart, icon: 'bag', primary: true },
          { act: 'prod', h: p.h, label: self.t('chip_product', { x: p.short }) },
          { act: 'menu', label: self.T.chip_menu }
        ]), { fast: true, focus: false });
        if (mqMobile.matches) self.close(false);
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { resource: cart, data: { source: 'product-form', itemCount: cart.item_count, variantId: id } } }));
      }).catch(function (err) {
        done();
        self.bot('<p>' + esc(err && err.message ? err.message : self.T.add_error) + '</p>', '', { fast: true, focus: false });
      });
    }

    /* ---------- Réponses ---------- */
    facts(p, topic) {
      var self = this;
      if (topic === 'prix') {
        var line = this.t('price_line', { price: p.price }) + (this.data.settings.shipCost ? ' ' + this.data.settings.shipCost + '.' : '');
        return '<p><strong>' + esc(p.short) + '</strong> · ' + esc(this.T.t_prix) + '</p><p>' + esc(line) + '</p>';
      }
      var f = p.factMap[topic];
      if (!f) return null;
      var text = f.replace(/\[conseiller\]/g, '').trim();
      return '<p><strong>' + esc(p.short) + '</strong> · ' + esc(self.T['t_' + topic]) + '</p><p>' + esc(text) + '</p>';
    }
    answerFact(p, topic) {
      this.state.ctx = p.h;
      var html = this.facts(p, topic);
      var f = p.factMap[topic] || '';
      if (!html) {
        this.bot('<p>' + esc(this.t('unknown_fact', { x: p.short })) + '</p>', this.topicChips(p, topic), { human: true, product: p, focus: false });
        return;
      }
      this.bot(html, this.topicChips(p, topic), { human: f.indexOf('[conseiller]') > -1, product: p });
    }
    topicChips(p, except) {
      var self = this;
      var keys = Object.keys(p.factMap).filter(function (k) { return k !== except && self.T['t_' + k]; }).slice(0, 6);
      var list = keys.map(function (k) { return { act: 'ptopic', h: p.h, v: k, label: self.T['t_' + k] }; });
      if (except !== 'prix') list.push({ act: 'ptopic', h: p.h, v: 'prix', label: this.T.t_prix });
      list.push({ href: p.url, act: 'link', label: this.T.see, icon: 'arrow' });
      list.push({ act: 'menu', label: this.T.chip_menu });
      return this.chips(list);
    }
    productMenu(p) {
      this.state.ctx = p.h;
      this.save();
      this.bot('<p>' + esc(this.t('prod_intro', { x: p.short })) + '</p>', this.card(p, { why: [] }) + this.topicChips(p));
    }
    answerFaq(i, topic) {
      var f = this.data.faq[i];
      if (!f) return;
      this.lastMotif = f.motif || null;
      var html = f.a + (f.lu ? '<p><a class="rf-asst__inline" href="' + esc(f.lu) + '" data-act="link">' + esc(f.ll || f.lu) + this.icon('arrow') + '</a></p>' : '');
      var chips = [];
      if (topic && !this.state.ctx) {
        this.data.products.forEach(function (p) { if (topic === 'prix' || p.factMap[topic]) chips.push({ act: 'ptopic', h: p.h, v: topic, label: p.short }); });
      }
      chips.push({ act: 'menu', label: this.T.chip_menu });
      if (!f.human) chips.push({ act: 'human', label: this.T.chip_human, icon: 'chat' });
      this.bot(html, this.chips(chips), { human: f.human, product: this.state.ctx && this.byHandle(this.state.ctx), motif: f.motif });
    }
    human() {
      var p = this.state.ctx && this.byHandle(this.state.ctx);
      this.bot('', this.chips([{ act: 'menu', label: this.T.chip_menu }]), { human: true, product: p, motif: this.lastMotif, fast: true });
    }
    recommend(zones, pain) {
      var self = this;
      var ranked = this.rank({ zone: zones });
      var two = this.pickTwo(ranked, zones);
      this.state.ctx = two.top.p.h;
      this.save();
      var label = zones.map(function (z) { return lcFirst(self.T['o_zone_' + z]); }).join(', ');
      var text = '<p>' + esc(this.t('reco_intro', { x: label })) + '</p>' + (pain ? '<p class="rf-asst__note">' + esc(this.T.reco_pain) + '</p>' : '');
      var extra = this.card(two.top.p, { kicker: this.T.result_best, why: this.why(two.top) });
      if (two.alt) extra += this.card(two.alt.p, { kicker: this.T.result_alt, alt: true, why: this.why(two.alt).slice(0, 2) });
      extra += this.chips([
        { act: 'quiz', label: this.T.chip_quiz, icon: 'check-circle', primary: true },
        { act: 'human', label: this.T.chip_human, icon: 'chat' }
      ]);
      this.bot(text, extra);
    }
    compare(prods, topic) {
      var self = this;
      var extra = prods.slice(0, 3).map(function (p) {
        var body = topic ? self.facts(p, topic) : null;
        if (!body) {
          var power = p.factMap.alimentation || '';
          body = '<p><strong>' + esc(p.short) + '</strong></p><p>' + esc(p.pitch) + (power ? ' ' + esc(power.replace(/\[conseiller\]/g, '').trim()) : '') + '</p>';
        }
        return '<div class="rf-asst__cmp">' + body + '<p class="rf-asst__cmp-foot"><span>' + esc(p.price) + '</span><a href="' + esc(p.url) + '" data-act="link">' + esc(self.T.see) + self.icon('arrow') + '</a></p></div>';
      }).join('');
      extra += this.chips(prods.slice(0, 3).map(function (p) { return { act: 'prod', h: p.h, label: self.t('chip_product', { x: p.short }) }; }).concat([{ act: 'quiz', label: this.T.chip_quiz, icon: 'check-circle' }]));
      this.bot('<p>' + esc(this.T.compare_intro) + '</p>', extra);
    }
    /* Sujet sans appareil désigné : si un seul appareil a cette information (embouts), on répond. */
    askProduct(topic) {
      var having = topic === 'prix' ? this.data.products : this.data.products.filter(function (p) { return p.factMap[topic]; });
      if (having.length === 1) { this.answerFact(having[0], topic); return; }
      this.bot('<p>' + esc(this.T.topic_pick) + '</p>', this.chips((having.length ? having : this.data.products).map(function (p) {
        return { act: 'ptopic', h: p.h, v: topic, label: p.short };
      })));
    }

    detectProducts(padded) {
      var hits = [];
      this.data.products.forEach(function (p) {
        var found = [];
        score(padded, p.nameList, found);
        if (found.length) hits.push({ p: p, names: found });
      });
      /* « masseur cou et épaules » ne doit pas désigner aussi l'épaulière. */
      return hits.filter(function (h) {
        return !hits.some(function (o) {
          return o !== h && h.names.every(function (n) {
            return o.names.some(function (m) { return m !== n && (' ' + m + ' ').indexOf(' ' + n + ' ') > -1; });
          });
        });
      }).map(function (h) { return h.p; });
    }
    bestTopic(padded) {
      var best = null;
      Object.keys(TOPICS).forEach(function (k) {
        var s = score(padded, TOPICS[k]);
        if (s >= 1.5 && (!best || s > best.s)) best = { id: k, s: s };
      });
      return best;
    }
    bestFaq(padded) {
      var best = null;
      this.data.faq.forEach(function (f, i) {
        var found = [];
        var s = score(padded, f.kw, found);
        if (s >= 2 && (!best || s > best.s)) best = { i: i, s: s, found: found };
      });
      return best;
    }

    reply(text) {
      var n = norm(text);
      if (!n) return;
      var padded = ' ' + n + ' ';
      this.lastMotif = null;
      var words = n.split(' ');
      this.via = 'text';
      if (words.length <= 3 && score(padded, HELLO) && !score(padded, HUMAN)) { this.bot('<p>' + esc(this.T.hello) + '</p>', this.menuChips(), { fast: true }); return; }
      if (words.length <= 4 && score(padded, THANKS)) { this.bot('<p>' + esc(this.T.thanks) + '</p>', this.menuChips(false), { fast: true }); return; }

      var prods = this.detectProducts(padded);
      var zones = Object.keys(ZONES).filter(function (z) { return score(padded, ZONES[z]) > 0; });
      var wantsAdvice = score(padded, CHOOSE) > 0 || score(padded, PAIN) > 0;
      var topic = this.bestTopic(padded);
      var faq = this.bestFaq(padded);
      var human = score(padded, HUMAN);
      var ctx = prods.length === 1 ? prods[0] : (!prods.length && this.state.ctx ? this.byHandle(this.state.ctx) : null);

      /* Conseil selon la zone (« j'ai mal au dos », « quel appareil pour les jambes ? »). */
      if (zones.length && wantsAdvice && !prods.length && (!faq || faq.s < 3)) { this.recommend(zones, score(padded, STRONG_PAIN) > 0); return; }
      /* Conseiller demandé explicitement. */
      if (human >= 4 || (human >= 2 && !topic && !faq)) { this.human(); return; }
      /* Deux appareils cités : comparaison. */
      if (prods.length >= 2 && (score(padded, COMPARE) > 0 || !faq)) { this.compare(prods, topic && topic.id); return; }

      if (topic && ctx) {
        /* Une question générale (« délais de livraison ») l'emporte si ses mots ne relèvent pas du sujet appareil. */
        var topicWords = TOPICS[topic.id];
        var faqOwn = faq && faq.found.some(function (w) { return topicWords.indexOf(w) === -1; });
        var factScore = topic.s + (prods.length ? 1 : 0.5);
        /* Appareil de la page sans cette information (« embout » sur le masseur cou) : on cherche ailleurs. */
        if (!prods.length && topic.id !== 'prix' && !ctx.factMap[topic.id] && (!faq || !faqOwn)) { this.askProduct(topic.id); return; }
        if (!faq || !faqOwn || factScore >= faq.s) { this.answerFact(ctx, topic.id); return; }
      }
      if (faq) { this.answerFaq(faq.i, topic && !ctx ? topic.id : null); return; }
      if (topic && !ctx) { this.askProduct(topic.id); return; }
      if (zones.length && !prods.length) { this.recommend(zones, score(padded, STRONG_PAIN) > 0); return; }
      if (prods.length === 1) { this.productMenu(prods[0]); return; }
      this.bot('<p>' + esc(this.T.fallback) + '</p>', this.menuChips(), { human: false });
    }

    /* ---------- Événements ---------- */
    onSubmit(e) {
      e.preventDefault();
      var v = this.input.value.trim();
      if (!v) return;
      this.input.value = '';
      this.state.last = v.slice(0, 300);
      this.user(v);
      this.reply(v);
    }
    onKey(e) {
      if (e.key === 'Escape' && this.state.open) { e.preventDefault(); this.close(); }
    }
    onClick(e) {
      var t = e.target;
      if (t.closest('[data-rf-asst-toggle]')) { if (this.state.open) this.close(); else this.open(); return; }
      if (t.closest('[data-rf-asst-close]')) { this.close(); return; }
      if (t.closest('[data-rf-asst-restart]')) { this.via = 'click'; this.restart(); return; }
      if (t.closest('[data-rf-asst-teaser-close]')) { this.hideTeaser(); clearTimeout(this.teaserTimer); return; }
      if (t.closest('[data-rf-asst-teaser-open]')) { this.open(); if (!this.state.quiz && this.data.settings.teaser && !this.data.context.product) { this.via = 'click'; this.user(this.T.chip_quiz); this.startQuiz(); } return; }
      var a = t.closest('[data-act]');
      if (!a || !this.contains(a) || a.disabled) return;
      var act = a.dataset.act;
      if (act === 'link' || act === 'mail') {
        if (act === 'mail') { try { if (this.state.last) sessionStorage.setItem(Q_KEY, this.state.last); } catch (err) { /* stockage indisponible */ } }
        if (mqMobile.matches) { this.state.open = false; this.save(); }
        return;
      }
      if (a.tagName === 'A') return;
      this.via = 'click';
      var label = (a.querySelector('span') || a).textContent;
      if (act !== 'human') this.lastMotif = null;
      switch (act) {
        case 'opt': this.pick(a); break;
        case 'next': this.next(a); break;
        case 'add': this.add(a); break;
        case 'quiz': this.user(label); this.startQuiz(); break;
        case 'menu': this.user(label); this.setProgress(null); this.state.quiz = null; this.menu(); break;
        case 'human': this.user(label); this.human(); break;
        case 'faq': this.user(label); this.answerFaq(Number(a.dataset.v)); break;
        case 'prod': { var p = this.byHandle(a.dataset.h); if (p) { this.user(label); this.productMenu(p); } break; }
        case 'ptopic': { var q = this.byHandle(a.dataset.h); if (q) { this.user(q.short + ' · ' + (this.T['t_' + a.dataset.v] || label)); this.answerFact(q, a.dataset.v); } break; }
      }
    }
  }

  customElements.define('rf-assistant', RfAssistant);
})();
